<script>
import OrderItem from '@/components/order/OrderItem'
import { MY_ORDERS_QUERY } from '@/graph/gql/orders.gql'

export default {
  name: 'MyOrdersView',
  components: {
    OrderItem
  },
  apollo: {
    orders: {
      query: MY_ORDERS_QUERY,
      update: data => data.myOrders
    }
  },
  data: () => ({ orders: [] }),
  computed: {
    pendingOrders() {
      return this.orders.filter(x => x.status === 'PENDING')
    },
    archivedOrders() {
      return this.orders.filter(x => x.status !== 'PENDING')
    }
  }
}
</script>

<template>
  <transition name="slide-up" appear>
    <!-- Orders view page -->
    <div class="view-grid">
      <div class="content-top">
        <div class="display-1 font-weight-bold mb-4">
          Your orders
        </div>

        <div>
          <v-skeleton-loader
            :loading="$apollo.loading"
            transition="fade-transition"
            class="mx-auto"
            type="list-item-avatar-two-line"
          >
            <div>
              <!-- Orders list -->
              <v-layout v-if="!$apollo.loading && orders.length" row wrap pa-1>
                <order-item
                  v-for="order in pendingOrders"
                  :key="order.id"
                  :order="order"
                />
              </v-layout>

              <div v-if="!$apollo.loading && orders.length" class="mt-4 mb-8">
                <h1 class="subtitle-1 font-weight-medium mb-0">
                  Get FREE food
                </h1>
                <p class="body-2 mb-6">
                  Earn RM5 for every friend you refer to Pona.
                </p>

                <v-btn
                  rounded
                  depressed
                  color="primary"
                  :to="{ name: 'PromotionsView' }"
                >
                  <v-icon size="15" left v-text="'$vuetify.icons.heart'" />
                  Refer a friend
                </v-btn>
              </div>

              <v-layout v-if="!$apollo.loading && orders.length" row wrap mt-2>
                <order-item
                  v-for="order in archivedOrders"
                  :key="order.id"
                  :order="order"
                />
              </v-layout>

              <!-- If empty -->
              <div
                v-if="!$apollo.loading && !orders.length && isOnline"
                class="orders-empty"
              >
                <span class="subtitle-1 font-weight-bold">
                  A fresh start
                </span>
                <p class="body-2">
                  Come back once you've made <br />
                  your first order
                </p>
              </div>
            </div>
          </v-skeleton-loader>
        </div>
      </div>
    </div>
  </transition>
</template>

<style lang="sass">
.orders-empty
  position: fixed
  top: 45vh
  left: 0
  width: 100%
  text-align: center
</style>
